import styled from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

/**
 * Sub-container for items on the right-side of the Toolbar.
 */
export const GridToolbarRightItems = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
`;

/**
 * Container to make a custom toolbar.
 * Expected use is to pass this container as a child to a Workspace/EditableDatagrid so it appears direclty above that Workspace/Grid.
 *
 * Then provide the elements desired as children to build a custom layout toolbar as desired.
 * In the example below, we have added an extra pill to the right hand side saying "Hello World".
 * E.g.
 *     <GridToolbarContainer>
 *       <GridToolbarWorkspaceSearch />
 *       <GridToolbarWorkspaceFiltersContainer />
 *       <GridToolbarWorkspaceRowCounter />
 *       <GridToolbarRightItems>
 *         <PillContainer>
 *           <Pill>Hello World</Pill>
 *         </PillContainer>
 *         <GridToolbarWorkspaceRefreshButton />
 *       </GridToolbarRightItems>
 *     </GridToolbarContainer>
 *
 */
const GridToolbarContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  border: 1px solid ${p4Tokens.colorNeutralBackground5};
  margin: 4px 0;
`;

export default GridToolbarContainer;
